import * as React from 'react';
import type { SVGProps } from 'react';
const SvgArrowLeft = (props: SVGProps<SVGSVGElement>) => {
  return <svg xmlns='http://www.w3.org/2000/svg' width='1em' height='1em' fill='none' viewBox='0 0 24 24' {...props} data-sentry-element="svg" data-sentry-component="SvgArrowLeft" data-sentry-source-file="ArrowLeft.tsx">
            <path fill='currentColor' d='M15 20.67c-.19 0-.38-.07-.53-.22l-6.52-6.52a2.74 2.74 0 0 1 0-3.86l6.52-6.52c.29-.29.77-.29 1.06 0s.29.77 0 1.06l-6.52 6.52c-.48.48-.48 1.26 0 1.74l6.52 6.52c.29.29.29.77 0 1.06-.15.14-.34.22-.53.22' data-sentry-element="path" data-sentry-source-file="ArrowLeft.tsx" />
        </svg>;
};
export default SvgArrowLeft;